import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PlayCircle } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/constants";
import { useAuth } from "@/context/AuthContext";
import { StatusBadge } from "@/components/StatusBadge";
import { AssessmentHistory } from "@/pages/RiderDetail";
import { BookReassessment } from "@/components/slots/BookReassessment";
import { RiderLogbook } from "@/components/slots/RiderLogbook";
import { AvatarEdit } from "@/components/Avatar";
import { RiderDocs } from "@/components/RiderDocs";

export default function MyStatus() {
  const { user } = useAuth();
  const [r, setR] = useState(null);

  useEffect(() => {
    if (user.rider_id) api.get(`/riders/${user.rider_id}`).then((res) => setR(res.data));
  }, [user.rider_id]);

  if (!r) return <div className="h-40 animate-pulse rounded-2xl bg-card" />;

  return (
    <div className="space-y-8">
      <div className="on-photo relative overflow-hidden rounded-3xl border">
        <img src="/brand/slider3-1.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#111317]/75" />
        <div className="relative space-y-4 p-6 sm:p-10">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary">My rider status</p>
          <div className="flex items-center gap-4">
            <AvatarEdit photo={r.photo} name={`${r.first_name} ${r.last_name}`} endpoint={`/avatars/rider/${r.id}`} onSaved={(p) => setR({ ...r, photo: p })} testid="my-avatar" />
            <h1 className="text-3xl font-extrabold tracking-tight sm:text-4xl">{r.first_name} {r.last_name}</h1>
          </div>
          <StatusBadge status={r.status} testId="my-status-badge" />
          <div className="grid max-w-md grid-cols-2 gap-4 pt-2">
            <div><div className="text-xs uppercase tracking-widest text-zinc-400">Last passed</div><div className="font-mono text-lg">{fmtDate(r.last_pass_date)}</div></div>
            <div><div className="text-xs uppercase tracking-widest text-zinc-400">Next check ride due</div><div data-testid="my-next-due" className="font-mono text-lg text-primary">{fmtDate(r.next_due_date)}</div></div>
          </div>
          <div className="flex flex-wrap gap-3"><Link to="/my-jobs" data-testid="my-jobs-btn" className="inline-flex items-center gap-2 rounded-full bg-destructive px-6 py-3 text-sm font-bold text-white">My jobs</Link>
          <Link to="/fleet" data-testid="my-bike-check-btn" className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-bold text-primary-foreground"><PlayCircle className="h-4 w-4" /> Bike checks & runs</Link></div>
        </div>
      </div>
      <BookReassessment status={r.status} />
      <RiderDocs mine />
      <RiderLogbook />
      <AssessmentHistory items={r.assessments} />
    </div>
  );
}
